import { render } from "./thirdSection.vue?vue&type=template&id=042c190c"
const script = {}

import "./thirdSection.vue?vue&type=style&index=0&id=042c190c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__